import { InterventionPreventive } from '@/models/InterventionPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { EQUIPEMENT_INTERVENTIONS } from './mutation-types';
import { EquipementInterventionsState, initialState } from './state';
import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';

export const mutations: MutationTree<EquipementInterventionsState> = {
    [EQUIPEMENT_INTERVENTIONS.SET_ITEMS](state, items: InterventionPreventive[]) {
        state.interventions = items;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_ALL_ITEMS](state, items: InterventionNonPreventive[]) {
        state.interventionsNonPreventives = items;
    },
    [EQUIPEMENT_INTERVENTIONS.RESET_ITEMS](state) {
        state.interventions = [];
        state.page = 0;
        state.count = 0;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_ACTIVE](state, active: boolean) {
        state.active = active;
    },
    [EQUIPEMENT_INTERVENTIONS.ADD_ITEMS](state, items: InterventionPreventive[]) {
        state.interventions = [...state.interventions, ...items];
    },
    [EQUIPEMENT_INTERVENTIONS.ADD_ALL_ITEMS](state, items: InterventionNonPreventive[]) {
        if (state.interventionsNonPreventives != null) {
            state.interventionsNonPreventives = [...state.interventionsNonPreventives, ...items];
        }
    },
    [EQUIPEMENT_INTERVENTIONS.SET_EQUIPEMENT_ID](state, id: string[]) {
        state.equipementId = id;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_FILTER_DATE_DEBUT](state, value: string) {
        state.filterDateDebut = value;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_FILTER_DATE_FIN](state, value: string) {
        state.filterDateFin = value;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [EQUIPEMENT_INTERVENTIONS.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [EQUIPEMENT_INTERVENTIONS.RESET](state) {
        Object.assign(state, initialState);
    },
};
